require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2016-07-dont-use-enum-umkay.json") })
        }
      }, "path---articles-2016-07-dont-use-enum-umkay");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2016-07-dont-use-enum-umkay!./.cache/json/articles-2016-07-dont-use-enum-umkay.json
// module id = 385
// module chunks = 231608221292675